import React from "react";
import { Box, Typography, styled } from "@mui/material";
import perspectiveGrid from "../../assets/home/Perspective Grid.svg";

// Wrapper
const HeroContainer = styled(Box)(({ theme }) => ({
  background: "#000",
  color: "#fff",
  position: "relative",
  overflow: "hidden",
   minHeight: "40vh",
  // reduce from full viewport,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  textAlign: "center",
  paddingTop: "2rem",
  [theme.breakpoints.down("sm")]: {
    minHeight: "1px",
    paddingTop: "2rem",
  },
}));

// Hero + Watermark wrapper
const HeroContent = styled(Box)(() => ({
  position: "relative",
  zIndex: 4,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginBottom: "0", // no extra big gap at the bottom
}));

const HeroText = styled(Typography)(({ theme }) => ({
  margin: 0,
  padding: 0,
  color: "#F4F4F4",
  fontFamily: "Farro, sans-serif",
  fontWeight: 700,
  lineHeight: 1.1,
  letterSpacing: "0.06em",
  textAlign: "center",
  fontSize: "64px",
  [theme.breakpoints.down("lg")]: { fontSize: "56px" },
  [theme.breakpoints.down("md")]: { fontSize: "42px" },
  [theme.breakpoints.down("sm")]: { fontSize: "22px" },
  maxWidth: "1300px",
}));

const Watermark = styled(Typography)(({ theme }) => ({
  position: "relative",
  zIndex: 3,
  marginTop: "0.8rem",
  fontWeight: 900,
  color: "rgba(63,61,61,0.45)",
  whiteSpace: "nowrap",
  pointerEvents: "none",
  fontSize: "clamp(48px, 7vw, 120px)",
  [theme.breakpoints.down("md")]: {
    fontSize: "48px",
    marginTop: "0.5rem",
  },
}));

const GridBackground = styled("img")(({ theme }) => ({
  width: "1200px",
  maxWidth: "95vw",
  height: "auto",
  pointerEvents: "none",
  userSelect: "none",
  display: "block",
  zIndex: 1,
  marginTop: "0.5rem", // **small gap between RUBAAI and grid**
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export default function HomePage() {
  return (
    <HeroContainer>
      <HeroContent>
        <HeroText variant="h1">Building a Smart Technology</HeroText>
        <HeroText variant="h1">For a Digital Tomorrow</HeroText>
        <Watermark>RUBAAI</Watermark>
        <GridBackground src={perspectiveGrid} alt="Perspective Grid" />
      </HeroContent>
    </HeroContainer>
  );
}
